exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".elementSettingWrapper--2qEoR {\n\twidth: 190px;\n\tpadding: 8px;\n\toverflow-y: auto;\n\theight: 100%;\n\tpadding-right: 20px;\n}", ""]);

// Exports
exports.locals = {
	"elementSettingWrapper": "elementSettingWrapper--2qEoR"
};